import PlatformActions from './PlatformActions'

export default class CRASH88Actions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'CRASH88',
      gameType: 'EGAME',
      gameCode: 'CRASH88-EGAME-002',
    }

    this.gameName = 'JetXt'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId, // ffc20559-7823-4ea3-b6c4-e3e9076d836f
      roundId, // e8747322-3599-4c7b-bd1e-5bba399de141
      betType: 'Casino',
      currency,
      betTime, // 2025-10-21T10:40:51.404+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        odds: 0,
        betType: 'Casino',
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId,
      refPlatformTxId: null,
      settleType: 'platformTxId',
      updateTime, // 2025-10-21T10:48:22.906+08:00
      roundId,
      betType: 'Casino',
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId,
      roundId,
      gameInfo: {
        odds: 0,
        betType: 'Casino',
      },
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
